import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import {
  AssignedCountry,
  AssignedMarketSegment,
  AssignedPortfolio,
  AssignedTerritory,
} from '../utils/principal-service/dto/Assignments.dto';

export type GlobalFilter = {
  allPortfoliosSelected: boolean;
  portfolios: AssignedPortfolio[] | null;
  allMarketSegmentsSelected: boolean;
  marketSegments: AssignedMarketSegment[] | null;
  allCountriesSelected: boolean;
  countries: AssignedCountry[] | null;
  allTerritoriesSelected: boolean;
  territories: AssignedTerritory[] | null;
};

export const initialFilters: GlobalFilter = {
  allPortfoliosSelected: true,
  portfolios: null,
  allMarketSegmentsSelected: true,
  marketSegments: null,
  allCountriesSelected: true,
  countries: null,
  allTerritoriesSelected: true,
  territories: null,
};

const GlobalFilterContext = createContext<{
  globalFilters: GlobalFilter;
  setGlobalFilters: Dispatch<SetStateAction<GlobalFilter>>;
}>({
  globalFilters: initialFilters,
  setGlobalFilters: () => undefined,
});

export const GlobalFilterProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [globalFilters, setGlobalFilters] = useState(initialFilters);

  return (
    <GlobalFilterContext.Provider value={{ globalFilters, setGlobalFilters }}>
      {children}
    </GlobalFilterContext.Provider>
  );
};

export const useGlobalFilters = () => {
  const context = useContext(GlobalFilterContext);
  if (!context) {
    throw new Error(
      'useGlobalFilters must be used within a GlobalFilterProvider',
    );
  }
  return context;
};
